export const PROPERTY_SETTINGS_SAVE_LABELS = {
	INACTIVE_EMAIL_RECIPIENT_ERROR: (recipientLabel: string): string =>
		`${recipientLabel} does not belong to this tenant or is inactive.`
} as const;
